import { useNomenclatureData, useUserConnected } from '@/hooks';
import { useFormContext, useWatch } from 'react-hook-form';
import { ScrollArea, Separator } from '@/components/ui';
import { AdminUserPermissionsEnum } from '@/lib/enum';
import { ToggleParam } from '@/components/custom';
import { Fragment } from 'react/jsx-runtime';
import { TFormData } from '.';

const FormEditUserRolesBodyPermissions = () => {

  const { selectOptions } = useNomenclatureData('AdminUserPermissionsEnum');
  const { control, formState: { isSubmitting }, setValue } = useFormContext<TFormData>();
  let permissions = useWatch({ control, name: 'roles.permissions' });
  let root = useWatch({ control, name: 'roles.root' });
  let _id = useWatch({ control, name: '_id' });
  const { userConnected } = useUserConnected();

  permissions = permissions ?? [];

  const isCurrentUser = userConnected?._id === _id;

  const changeState = (permission: AdminUserPermissionsEnum, checked: boolean) => {
    let newPermissions = [...permissions].filter(l => !!l);

    if (checked) {
      newPermissions.push(permission);
    } else {
      newPermissions = [...newPermissions].filter(l => l !== permission);
    }

    setValue('roles.permissions', newPermissions);
  };

  return (
    <ScrollArea className='flex-1 overflow-auto flex flex-col py-3 px-0 md:px-5'>
      <div className='space-y-2'>
        {
          [...selectOptions]
            .sort((a, b) => a.title! > b.title! ? 1 : -1)
            .map(
              l => (
                <Fragment key={l.value}>
                  <ToggleParam
                    title={l.value!}
                    description={l.title}
                    disabled={isCurrentUser || isSubmitting || root}
                    switchColorOnChecked='#9333ea'
                    checked={permissions.includes(l.value as any)}
                    onCheckedChange={checked => changeState(l.value as any, checked)}
                    className='border-0 p-0' />
                  <Separator />
                </Fragment>
              )
            )
        }
      </div>
    </ScrollArea>
  );

};

export default FormEditUserRolesBodyPermissions;
